import React, {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const ListrakScript = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {listrak} = commerceAPI
    const {config} = listrak || {}

    var listrakEnabled = false
    var listrakSubscriptionTagUrl = null
    var listrakMerchantID = null

    try {
        const jsonConfig = JSON.parse(config)
        listrakEnabled = jsonConfig.enabled
        listrakSubscriptionTagUrl = jsonConfig.subscribeTagURL
        listrakMerchantID = jsonConfig.merchantID
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (listrakEnabled && listrakSubscriptionTagUrl && listrakMerchantID) {
            const script = document.createElement('script')
            script.src = listrakSubscriptionTagUrl + '?m=' + listrakMerchantID + '&v=1'
            script.type = 'text/javascript'
            script.async = true
            script.defer = true
            document.body.appendChild(script)

            return () => {
                document.body.removeChild(script)
            }
        }
    }, [listrakEnabled, listrakSubscriptionTagUrl, listrakMerchantID])

    return <></>
}

export default ListrakScript
